import { getGimacCountryDialCode, getGimacCountryFlag, GimacParticipant } from '~/entities/schemas/gimacCountry';

// Mapping code participant -> prefixes telephoniques
// Extensible : ajouter les codes participants et leurs prefixes au besoin
/* eslint-disable @typescript-eslint/naming-convention */
export const PARTICIPANT_PREFIX_MAP: Record<string, string[]> = {
  // Cameroun - MTN : 650-654, 670-679, 680-689
  12002: [
    '650',
    '651',
    '652',
    '653',
    '654',
    '670',
    '671',
    '672',
    '673',
    '674',
    '675',
    '676',
    '677',
    '678',
    '679',
    '680',
    '681',
    '682',
    '683',
    '684',
    '685',
    '686',
    '687',
    '688',
    '689',
  ],
  // Cameroun - Orange : 655-659, 690-699
  12001: ['655', '656', '657', '658', '659', '690', '691', '692', '693', '694', '695', '696', '697', '698', '699'],
  // Gabon
  41001: ['74', '77'], // Airtel GA
  41002: ['62', '66'], // Moov Money GA
  14007: ['79', '70'], // Swap Sarl GA
  // Congo
  32001: ['05', '06'], // Airtel CG
  32002: ['04', '05'], // MTN CG
};

/**
 * Detecte l'operateur a partir du numero de telephone et des participants MM d'un pays
 * @param phoneNumber - Numero de telephone (sans indicatif)
 * @param participants - Liste des participants MM du pays selectionne
 * @returns Le participant detecte ou null
 */
export const detectOperatorFromPhone = (
  phoneNumber: string,
  participants: GimacParticipant[],
): GimacParticipant | null => {
  const cleanPhone = phoneNumber.replace(/\D/g, '');

  if (cleanPhone.length < 2) {
    return null;
  }

  const phonePrefix = cleanPhone.substring(0, 4);

  for (const participant of participants) {
    const prefixes = PARTICIPANT_PREFIX_MAP[participant.code];
    if (!prefixes) continue;

    for (const prefix of prefixes) {
      if (phonePrefix.startsWith(prefix)) {
        return participant;
      }
    }
  }

  return null;
};

/**
 * Recupere le drapeau emoji pour un code pays
 */
export const getFlagForCountry = (countryCode: string): string => getGimacCountryFlag(countryCode);

/**
 * Recupere l'indicatif telephonique pour un code pays GIMAC (champ `code` racine)
 */
export const getDialCodeForCountry = (countryCode: string): string => getGimacCountryDialCode(countryCode);
